<template>
  <three-step-approval
    api="home-status-request"
    perm-prefix="approve_status_home"
    :columns="columns"
    final-word="ປິດ/ເປີດ"
    final-icon="mdi-swap-horizontal"
    :final-confirm="(n) => `ປິດ/ເປີດສາຍບ້ານ ${n} ລາຍ? ເປີດ (active) ຈະເກັບໄດ້, ປິດ (inactive) ຈະເກັບບໍ່ໄດ້.`"
  />
</template>

<script>
import ThreeStepApproval from '@/views/threeStep/ThreeStepApproval.vue';

export default {
  name: 'HomeStatusApproval',
  components: { ThreeStepApproval },
  title() {
    return 'Vientiane Waste Co-Dev|Home Status Approval';
  },
  data() {
    return {
      columns: [
        { text: 'ລູກຄ້າ', value: 'customer_name' },
        { text: 'ແພັກເກດ', value: 'package' },
        { text: 'ປ່ຽນຈາກ → ເປັນ', value: 'to_status', sortable: false },
      ],
    };
  },
};
</script>
